import {ApiEndpointUrl, Logintoken} from "../../common";
export const addressPoint = { list:ApiEndpointUrl + "addresses",
                              add:ApiEndpointUrl + "addresses/create?token="+Logintoken(),     
                              delete:ApiEndpointUrl + "addresses/create?token="+Logintoken(), };
  